import React from 'react';
import './PlayerList.css';

const ROLE_NAMES = {
  villager: 'Dân Làng',
  werewolf: 'Ma Sói',
  seer: 'Tiên Tri',
  doctor: 'Bảo Vệ',
  witch: 'Phù Thuỷ',
  hunter: 'Thợ săn',
  lycan: 'Bán sói'
};

const VOTING_PHASES = ['voting-accuse', 'defense', 'voting-decision'];

function PlayerList({ players, showRole = false, myId = null, votes = null, decisionVotes = null, phase = null, accusedPlayer = null }) {
  // Helper function to get vote information for a player
  const getVoteInfo = (playerId) => {
    if (!phase || !VOTING_PHASES.includes(phase)) {
      return null;
    }

    if (phase === 'voting-decision') {
      // For voting-decision, show decision (kill or change-mind)
      if (!decisionVotes || !decisionVotes[playerId]) {
        return null;
      }
      const decision = decisionVotes[playerId];
      return decision === 'kill' ? 'Đã quyết định: Giết' : 'Đã quyết định: Đổi ý';
    } else if (phase === 'voting-accuse' || phase === 'defense') {
      // Show who each player voted for in the voting-accuse phase
      if (!votes || !votes[playerId]) {
        console.log('[PlayerList] no votes available', { phase, votes, playerId });

        return null;
      }
      const voteTargetId = votes[playerId];
      const targetPlayer = players.find(p => p.id === voteTargetId);

      return targetPlayer ? `Đã bỏ phiếu cho ${targetPlayer.name}` : null;
    }

    return null;
  };

  return (
    <div className="player-list-container">
      <h3>Danh Sách Người Chơi ({players.length})</h3>
      <ul className="player-list">
        {players.map((player) => {
          const voteInfo = getVoteInfo(player.id);
          return (
            <li
              key={player.id}
              className={`player-item ${player.isAlive ? 'alive' : 'dead'}`}
            >
              <div>
                <span className="player-name">
                  {player.name}
                  {myId === player.id && ' (Bạn)'}
                </span>
                {showRole && player.role && (
                  <span className={`role-badge role-${player.role}`}>
                    {ROLE_NAMES[player.role]}
                  </span>
                )}
                {voteInfo && (
                  <div style={{ fontSize: '12px', color: '#666', marginTop: '4px', fontStyle: 'italic' }}>
                    {voteInfo}
                  </div>
                )}
              </div>
              <div className="player-status">
                {player.isAlive ? '🟢 Sống' : '🔴 Chết'}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default PlayerList;





